module.exports = __webpack_public_path__ + "img/ic_caret_right.svg";